import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'cdw-ae-platform-admin-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class PlatformAdminFooterComponent {
  readonly isProduction = environment.production ?? false;
  readonly revision = environment.revision || 'unknown';
  readonly version = environment.version || '0.0.0';
  readonly privacyUrl = environment.urls.legal.privacyNotice;
}
